/**
 * @generated SignedSource<<3204c7905b657fd5bd0b0907ffb5af30>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type dividendsPage_ShareholderDeleteMutation$variables = {
  id: string;
};
export type dividendsPage_ShareholderDeleteMutation$data = {
  readonly shareholderDelete: {
    readonly deleted: boolean | null | undefined;
    readonly errors: ReadonlyArray<{
      readonly message: string;
    }>;
  } | null | undefined;
};
export type dividendsPage_ShareholderDeleteMutation = {
  response: dividendsPage_ShareholderDeleteMutation$data;
  variables: dividendsPage_ShareholderDeleteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deleted",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "dividendsPage_ShareholderDeleteMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ShareholderDeleteMutationPayload",
        "kind": "LinkedField",
        "name": "shareholderDelete",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "dividendsPage_ShareholderDeleteMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ShareholderDeleteMutationPayload",
        "kind": "LinkedField",
        "name": "shareholderDelete",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "b4b3f1028adfe72bbd70def264086246",
    "id": null,
    "metadata": {},
    "name": "dividendsPage_ShareholderDeleteMutation",
    "operationKind": "mutation",
    "text": "mutation dividendsPage_ShareholderDeleteMutation(\n  $id: ID!\n) {\n  shareholderDelete(id: $id) {\n    deleted\n    errors {\n      message\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "3579c325c8b9aa87a382ddc9405ca412";

export default node;
